import { FunctionComponent, useEffect } from 'react';
import Input from '@media-ui/core/src/components/Input';
import { IInputProps } from '@media-ui/core/src/components/Input/Input.types';
import { useFormContext } from 'react-hook-form';
import IMask from 'imask';
import FormField from '../FormField';
import { FormFieldProps } from '../FormField/FormField.types';
import Text from '@media-ui/core/src/components/Text';
import * as T from './PetsInput.types';
import * as s from './PetsInput.css';
let maskInstance: T.IMarkInstance;
const PetsInput: FunctionComponent<T.PetsInputProps & Omit<IInputProps, 'pattern' | 'validate'> & Omit<FormFieldProps, 'pattern' | 'validate'>> = ({ label, name, required, defaultValue, pattern, validate, triggerOnChange, inputHint, mask, ...rest }) => {
    const { getValues, setValue, trigger } = useFormContext();
    const defaultVal = defaultValue || '';
    const getMaskedValue = (value: string) => maskInstance?.resolve(value);
    const handleChange = (val: string) => {
        const value = mask ? getMaskedValue(val) : val;
        setValue(name, value);
        triggerOnChange && trigger(name);
    };
    const getDefaultValue = () => {
        return getValues(name) || defaultVal;
    };
    useEffect(() => {
        if (mask) {
            maskInstance = IMask.createMask({
                mask: mask as IMask.MaskedDynamic,
            });
        }
        setValue(name, getValues(name) || defaultVal);
        triggerOnChange && trigger(name);
    }, []);
    return (<FormField pattern={pattern} validate={validate} required={required} label={label} name={name}>
      <Input onChange={(e): void => {
            handleChange(e.target.value);
        }} defaultValue={getDefaultValue()} type="text" name={name} value={getValues(name)} {...rest}/>
      {inputHint && (<Text tag="span" className={s.inputHint}>
          {inputHint}
        </Text>)}
    </FormField>);
};
export default PetsInput;
